import { render, staticRenderFns } from "./vendor-details.vue?vue&type=template&id=b2bb922a&scoped=true"
import script from "./vendor-details.vue?vue&type=script&lang=js"
export * from "./vendor-details.vue?vue&type=script&lang=js"
import style0 from "./vendor-details.vue?vue&type=style&index=0&id=b2bb922a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bb922a",
  null
  
)

export default component.exports